export default __webpack_public_path__ + "static/media/ThingsThatSting_03.18f45a9f.png";